import {
  UIRouter,
  ResolveTypes
} from '@uirouter/angular';

import { AuthService } from '../auth.service';

export function resolveLoadUserFn(authService: AuthService, router: UIRouter) {
  return new Promise((resolve, reject) => {
    authService.getCurrentUser()
      .subscribe(
        (result) => {
          if (result !== null) {
            console.log('loadUser result');

            resolve(result ? result : {});
          }
        },
        () => {
          console.log('error');
          resolve({});
        }
      );
  });
}

export let resolveLoadUser: ResolveTypes = {
  token: 'loadUser',
  deps: [AuthService, UIRouter],
  resolveFn: resolveLoadUserFn,
  policy: {async: 'WAIT'}
};



// WEBPACK FOOTER //
// ./src/app/auth/resolves/loadUser.resolve.ts